import { render } from "./MiniWizardStickyGiftCards.vue?vue&type=template&id=23fb329a"
import script from "./MiniWizardStickyGiftCards.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyGiftCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__